export const STORAGE_KEYS = {
  token: 'TOKEN',
  tempToken: 'TEMP_TOKEN',
  credentials: 'CREDENTIALS',
  userData: 'USER_DATA',
  fcmToken: 'FCM_TOKEN',
};
